export default __webpack_public_path__ + "static/media/private-mobile.d92c2c95.png";